import { PageConfig } from "@shared/components/page-config";
import { FC } from "react";
import NotFound from "pages/404";
import useLandingConfig from "./hooks/useLandingConfig";
import { AdminHeader } from "@shared/components";
import { useLanding } from "./hooks/useLanding";

const LandingPage: FC<{ is404?: boolean }> = ({ is404 }) => {
  const { data, hasError, FestivalComponent, isAdmin } = useLanding();
  const festival = data?.data.festival;
  const landingPageConfig = useLandingConfig(
    festival?.title ?? "",
    festival?.description ?? ""
  );

  const isFestivalDeactive = festival && festival?.is_active === false;
  if (hasError || isFestivalDeactive || is404) return <NotFound />;
  return (
    <PageConfig config={landingPageConfig}>
      {isAdmin ? (
        <AdminHeader
          editSetting={{
            withEdit: true,
            url: `https://faradars.org/admin/panel/fara/festival/${data?.data.festival.id}/edit`,
            title: "ویرایش جشنواره",
          }}
        />
      ) : null}

      <FestivalComponent festivalData={data} />
    </PageConfig>
  );
};

export default LandingPage;
